// generated from 21_186 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedCampaignOrCanvasWithTagFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_campaign_or_canvas_with_tag_filter"),
  comparison_key: z.enum([
    "6", // 17_401 (82.13%)
    "4", // 3_127 (14.76%)
    "5", // 487 (2.30%)
    "3", // 171 (0.81%)
  ]),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 10_687 (50.44%), defined 10_499 (49.56%)
  raw_value: z
    .union([
      // number samples: 10_106 (96.26%)
      // integer: 8_460 (83.71%)
      // avg: 16.75, min: 0, max: 1400
      z.number().min(0),
      // string samples: 393 (3.74%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 20_528 (96.89%)
    // integer: 16_749 (81.59%)
    // avg: 15.06, min: 0, max: 1400
    z.number().min(0),
    // string samples: 658 (3.11%)
    common.date,
  ]),
  varies_by_app_group: z.literal(true),
});
